// extracted by mini-css-extract-plugin
export default {"space40":"index_space40_Cbxxg","space10":"index_space10_oFbYF"};